export default __webpack_public_path__ + "static/media/127.60ac973c.gif";